import React from "react";
import '../css/common.css'
import { useNavigate } from 'react-router-dom';


// Import logos
import logoOne from '../resource/icons/1.png';
import logoTwo from '../resource/icons/2.png';
import logoThree from '../resource/icons/3.png';
import logoFour from '../resource/icons/4.png';
import logoFive from '../resource/icons/5.png';
import logoSix from '../resource/icons/6.png';
import logoSeven from '../resource/icons/7.png';
import logoEight from '../resource/icons/8.png';
import logoNine from '../resource/icons/9.png';
import logoTen from '../resource/icons/10.png';
import logoEleven from '../resource/icons/community service.png'

import logo from '../resource/7.png';
import name from '../resource/Bhaddeka Vihari.png';
import nameTwo from '../resource/Monastery.png';
import TitleChnage from "../Hook/TitleChnage";

const Home = () => {
  const navigate = useNavigate();

  TitleChnage("Home Page")


  const handleClick = (event) => {

    const pathMap = {
      aboutus : '/aboutus',
      events: '/event',
      community:'/community',
      dana: '/dana',
      meditate: '/meditate',
      talks: '/talks',
      arama: '/arama',
      hermitage: '/hermitage',
      donations: '/donations',
      gallery: '/gallery',
      contact:'/contact'
    }

    const path = event.currentTarget.id;
    const targetPath = pathMap[path]

    if (targetPath){
      navigate(targetPath)
    }
  }

  const logos = [
    { src: logoOne, label: "About Us",id: "aboutus" },
    { src: logoTwo, label: "Events",id: "events"  },
    { src: logoEleven, label: "Community Service" , id: "community"},
    { src: logoThree, label: "Dana",id: "dana"  },
    { src: logoFour, label: "Meditate With Us",id: "meditate"  },
    { src: logoFive, label: "Dhamma Talks",id: "talks"  },
    { src: logoSix, label: "Arama Poojawa",id: "arama"  },
    { src: logoSeven, label: "Monastery Development" ,id: "hermitage" },
    { src: logoEight, label: "Donation",id: "donations"  },
    { src: logoNine, label: "Photo & Video Gallery",id: "gallery"  },
    { src: logoTen, label: "Contact Us",id: "contact"  },
  ];


  return (
    <div className='page home-page'>

      {/* Top section */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>

        {/* Logo + Name row */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap"
        }}>

          <div className="logo">
            <img src={logo} alt="Main Logo" width={250} />
          </div>

          <div className="name" style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <img className="name-img-1" src={name} alt="Bhaddeka Vihari" width={900} />
            <img className="name-img-2" src={nameTwo} alt="Monastery" width={600} />
          </div>

        </div>

        {/* Notice Banner */}
        <div style={{
          marginTop: "10px",
          padding: "20px",
          maxWidth: "850px",
          background: "#fff8e1",
          border: "2px solid #d4af37",
          borderRadius: "8px",
          textAlign: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
        }}>

          <h3 style={{
            marginBottom: "10px",
            color: "#8d6e00",
            fontWeight: "bold"
          }}>
            Website Under Construction
          </h3>

          <p style={{
            margin: 0,
            fontSize: "16px",
            color: "#5d4037",
            lineHeight: "1.6"
          }}>
            This website is currently under development and should not be used
            as a source of information at this time.
            <br/><br/>
            We appreciate your patience and understanding.
          </p>

        </div>

      </div>

      {/* Menu icons */}
      <div className="lower-box">
        {logos.map((item, index) => (
          <button key={index} id={item.id} onClick={handleClick}>
            <img src={item.src} alt={item.label} width={100} />
            <label>{item.label}</label>
          </button>
        ))}
      </div>
    </div>
  );
}


export default Home